var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    {
      staticStyle: { "margin-left": "10px" },
      attrs: { id: "developStandardManage-list" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "ivu-col ivu-col-span-xs-24 ivu-col-span-sm-24 ivu-col-span-md-24 ivu-col-span-lg-24",
        },
        [
          _c(
            "h2",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v(_vm._s(_vm.titleData[_vm.currentRowIndex]))]
          ),
        ]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.type !== 3,
              expression: "type!==3",
            },
          ],
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: {
            stripe: "",
            data: _vm.listData,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "max-height": _vm.tableHeight1,
            border: true,
            "header-align": "center",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "monthYear",
              label: "岁:月",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "down3sd",
              label: "-3SD",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "down2sd",
              label: "-2SD",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "down1sd",
              label: "-1SD",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "median",
              label: "中",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "up1sd",
              label: "+1SD",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "up2sd",
              label: "+2SD",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "up3sd",
              label: "+3SD",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.type === 3,
              expression: "type===3",
            },
          ],
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: {
            stripe: "",
            data: _vm.listData,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "max-height": _vm.tableHeight2,
            border: true,
            "header-align": "center",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "height",
              label: "身高(cm)",
              "show-overflow-tooltip": "",
            },
          }),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "体重(kg)" } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "down3sd",
                  label: "-3SD",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "down2sd",
                  label: "-2SD",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "down1sd",
                  label: "-1SD",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "median",
                  label: "中",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "up1sd",
                  label: "+1SD",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "up2sd",
                  label: "+2SD",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "up3sd",
                  label: "+3SD",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }